export enum ENgapFilters {
	diabetic = "diabetic",
	cancer = "cancer",
	mucoviscidose = "mucoviscidose",
	dependant = "dependant",
	hadssiad = "hadssiad",
	hn = "hn"
}